import React from 'react';
import { SearchInput } from 'evergreen-ui';

interface Props {
  handleFilter: (value: string) => void;
  value: string;
}

const SearchSequence: React.FC<Props> = ({ handleFilter, value }) => {
  return (
    <div className='sequence-card__search'>
      <SearchInput
        placeholder='Search Sequence...'
        width='100%'
        onChange={(value: string) => handleFilter(value)}
        value={value}
      />
    </div>
  );
};

export default SearchSequence;
